module.exports = {

    data() {
        return {
            showMonthlyPaymentOption: false,
            payment: null,
            couponApplied: null,
            form: new Form({
                user_id: null,
                training_quarter_id: null,
                with_payment: true,
                stripe_token: null,
                is_monthly_payment: false,
                receipt_to: null,
            }).dontClear(),
            request: new Form({
                is_monthly_payment: false,
                user_id: App.config.userId
            }).dontClear(),
        }
    },

    created() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('id')) {
            this.request.user_id = urlParams.get('id')
            this.search();
        }
        App.bus.$on('discount-applied', discount => {
            this.search()
            this.couponApplied = discount;
        })
        App.bus.$on('submit-payment', this.checkout)
    },

    mounted() {
        document.getElementById('payment_user_id').focus()
    },

    methods: {
        search() {
            this.request.post('/electrical-training-program/make-a-payment')
                .then(response => {
                    this.showMonthlyPaymentOption = response.show_monthly_payments_option;
                    this.payment = response;
                    this.form.user_id = response.user.id;
                    this.form.is_monthly_payment = response.is_monthly_payment,
                    this.form.training_quarter_id = response.next_quarter_id;
                }).catch(errors => {
                Alert.timer(errors.first(), 'error').then(() => {
                    // this.redirectTo('/')
                })
            })
        },

        checkout() {
            this.form.patch('/electrical-training-program/make-a-payment')
                .then(response => {
                    Alert.timer(response.message).then(() => this.redirectTo('/'));
                })
                .catch(errors => Alert.error(errors.first()))
        },

        exit() {
            this.payment = null;
            this.form.user_id = '';
            this.request.user_id = '';
            this.request.training_quarter_id = null;
        },
    },

    watch: {
        'request.is_monthly_payment'(value) {
            // this.form.is_monthly_payment = value
            this.search()
        },
    },
    computed: {
        isDisabled() {
            return !this.form.stripe_token || this.form.isSubmitted;
        }
    }
}
